import megaclock from "~/assets/icons/megaclock.png";

export function MegaClock() {
    return (
        <img
            src={megaclock}
            alt="fail"
            class="mx-auto w-1/2 max-w-[30vh] flex-shrink"
        />
    );
}
